package de.connect2x.timmy.brandings.aokTheme

import androidx.compose.ui.graphics.Color

//Light theme template
internal val md_theme_light_primary = aok_primary_dark_green
internal val md_theme_light_onPrimary = aok_primary_light_white
internal val md_theme_light_primaryContainer = aok_primary_light_white
internal val md_theme_light_onPrimaryContainer = aok_primary_dark_green
internal val md_theme_light_secondary = aok_structure_pastel_green
internal val md_theme_light_onSecondary = aok_grey_8
internal val md_theme_light_secondaryContainer = aok_primary_dark_green
internal val md_theme_light_onSecondaryContainer = aok_primary_light_white
internal val md_theme_light_tertiary = aok_grey_8
internal val md_theme_light_onTertiary = aok_primary_light_white
internal val md_theme_light_tertiaryContainer = aok_primary_dark_green
internal val md_theme_light_onTertiaryContainer = aok_primary_light_white
internal val md_theme_light_error = aok_has_error
internal val md_theme_light_onError = Color(0xFFFFFFFF)
internal val md_theme_light_errorContainer = Color(0xFFFFDADA)
internal val md_theme_light_onErrorContainer = Color(0xFF723338)
internal val md_theme_light_background = aok_primary_light_white
internal val md_theme_light_onBackground = Color(0xFF171D19)
internal val md_theme_light_surface = aok_primary_light_white
internal val md_theme_light_onSurface = aok_grey_8
internal val md_theme_light_surfaceVariant = aok_primary_light_white
internal val md_theme_light_onSurfaceVariant = Color(0xFF404943)
internal val md_theme_light_outline = Color(0xFF707973)
internal val md_theme_light_outlineVariant = Color(0xFFC0C9C1)
internal val md_theme_light_scrim = Color(0xFF000000)
internal val md_theme_light_inverseSurface = Color(0xFF2C322E)
internal val md_theme_light_inverseOnSurface = Color(0xFFEDF2EC)
internal val md_theme_light_inversePrimary = aok_grey_8
internal val md_theme_light_surfaceDim = Color(0xFFD6DBD5)
internal val md_theme_light_surfaceBright = Color(0xFFF5FBF5)
internal val md_theme_light_surfaceContainerLowest = aok_primary_light_white
internal val md_theme_light_surfaceContainerLow = aok_primary_light_white
internal val md_theme_light_surfaceContainer = aok_primary_light_white
internal val md_theme_light_surfaceContainerHigh = aok_primary_light_white
internal val md_theme_light_surfaceContainerHighest = aok_structure_pastel_green


// Dark theme template (mostly used for lightness/saturation)
internal val md_theme_dark_primary = Color(0xFF8ED5B0)
internal val md_theme_dark_onPrimary = Color(0xFF040404)
internal val md_theme_dark_primaryContainer = Color(0xFF040404)
internal val md_theme_dark_onPrimaryContainer = Color(0xFFEEEEEE)
internal val md_theme_dark_secondary = Color(0xFF384144)
internal val md_theme_dark_onSecondary = Color(0xFFFFFFFF)
internal val md_theme_dark_secondaryContainer = Color(0xFF666666)
internal val md_theme_dark_onSecondaryContainer = Color(0xFFE6E6E6)
internal val md_theme_dark_tertiary = Color(0xFFE6E6E6)
internal val md_theme_dark_onTertiary = Color(0xFF101010)
internal val md_theme_dark_tertiaryContainer = Color(0xFF555555)
internal val md_theme_dark_onTertiaryContainer = Color(0xFFE6E6E6)
internal val md_theme_dark_error = Color(0xFF8A0D1D)
internal val md_theme_dark_errorContainer = Color(0xFFFFDAD6)
internal val md_theme_dark_onError = Color(0xFFFFFFFF)
internal val md_theme_dark_onErrorContainer = Color(0xFF410002)
internal val md_theme_dark_background = Color(0xFF121212)
internal val md_theme_dark_onBackground = Color(0xFFFFFFFF)
internal val md_theme_dark_surface = Color(0xFF040404)
internal val md_theme_dark_onSurface = Color(0xFFFFFFFF)
internal val md_theme_dark_surfaceVariant = Color(0xFF274d61)
internal val md_theme_dark_onSurfaceVariant = Color(0xFFFFFFFF)
internal val md_theme_dark_outline = aok_structure_pastel_green
internal val md_theme_dark_inverseOnSurface = Color(0xFF161616)
internal val md_theme_dark_inverseSurface = Color(0xFFA6EEFF)
internal val md_theme_dark_inversePrimary = Color(0xFF00677E)
internal val md_theme_dark_outlineVariant = Color(0xFF40484B)
internal val md_theme_dark_scrim = Color(0xFF101010)
internal val md_theme_dark_surfaceDim = Color(0xFF0F1511)
internal val md_theme_dark_surfaceBright = Color(0xFF353B36)
internal val md_theme_dark_surfaceContainerLowest = Color(0xFF0A0F0C)
internal val md_theme_dark_surfaceContainerLow = Color(0xFF171D19)
internal val md_theme_dark_surfaceContainer = Color(0xFF1B211D)
internal val md_theme_dark_surfaceContainerHigh = Color(0xFF262B28)
internal val md_theme_dark_surfaceContainerHighest = Color(0xFF303632)

//messenger colors light theme
internal val messenger_theme_light_success = Color(0xFF8ED75E)
internal val messenger_theme_light_warning = Color(0xFFeedc82)
internal val messenger_theme_light_error = Color(0xFFD24603)
internal val messenger_theme_light_neutral = Color(0xFF767676)
internal val messenger_theme_light_preview_content = Color.White.copy(alpha = 0.7f)
internal val messenger_theme_light_preview_scrim = Color.Black.copy(alpha = 0.7f)
internal val messenger_theme_light_link_other = aok_structure_deep_green
internal val messenger_theme_light_link_own = aok_structure_deep_green
internal val messenger_theme_light_users = listOf(
    aok_structure_deep_green
)
/* //Default rotating colors for users
internal val messenger_theme_light_users = listOf(
    Color(0xFFA41515),
    Color(0xFFA46715),
    Color(0xFF908213),
    Color(0xFF139057),
    Color(0xFF138190),
    Color(0xFF135F90),
    Color(0xFF132F90),
    Color(0xFF3F1390),
    Color(0xFF6E1390),
    Color(0xFF901355)
)
*/

internal val messenger_theme_dark_success = Color(0xFF51CC25)
internal val messenger_theme_dark_warning = Color(0xFFeedc82)
internal val messenger_theme_dark_error = Color(0xFFFB5607)
internal val messenger_theme_dark_neutral = Color(0xFF767676)
internal val messenger_theme_dark_preview_content = Color.White.copy(alpha = 0.7f)
internal val messenger_theme_dark_preview_scrim = Color.Black.copy(alpha = 0.7f)
internal val messenger_theme_dark_link_other = aok_structure_deep_green
internal val messenger_theme_dark_link_own = aok_structure_deep_green
internal val messenger_theme_dark_users = listOf(aok_structure_deep_green)
/*
//Default rotating colors for users
internal val messenger_theme_dark_users = listOf(
   Color(0xFFe61c1c),
   Color(0xFFdb8818),
   Color(0xFFd6c11c),
   Color(0xFF1cd480),
   Color(0xFF18b6cc),
   Color(0xFF1b8ad1),
   Color(0xFF4767d6),
   Color(0xFF753cde),
   Color(0xFFa424d4),
   Color(0xFFe61e87)
)
*/

